module.exports = __webpack_public_path__ + "img/bot.95e2d2bf.svg";